module.exports = __webpack_public_path__ + "1aff91aabadf1a8eba9e5ee39384157d.pdf";